import React, { Component } from 'react'
import axios from 'axios'
import { get } from 'lodash'

class resetForm extends Component {
  state = {
    password: '',
    passwordConfirm: '',
    validToken: '',
    checkingToken: '',
    passwordUpdated: false,
    errorMessage: '',
  }
  getVal(key){
    return get(this.props.metadataMap, key)
 }

  componentDidMount() {
  	this.checkTokenAuth()
  }

  checkTokenAuth = () => {
  	 axios({
       baseURL: window.settings.apiBaseUrl, 
       url: `/identity/reset-password-token/${window.document.location.search.split('=')[1]}`,
       method: 'GET',
       headers: {
        'x-api-key': window.settings.baseAPIKey
       }
    }).then((response) => {
      if(response.data.isValidToken){
        this.setState({
          checkingToken: false,
          validToken: true
        })
      }
    }).catch(error =>{
      console.log(error.response.data.error)
      this.setState({
        checkingToken: false,
        validToken: false
      })
      this.redirectToHomepage(5000)
    })
  }

	handleSubmit = (e) => {
    e.preventDefault()
    this.setState({ errorMessage: '' })
   	if (!this.showFormErrors() && !this.props.simplified) {
      console.log('form is invalid: do not submit')
    } else {
      const formData = document.forms.resetPassword
    	const data = {
      	resetToken: window.location.search.split('=')[1],
        newPassword: formData.password.value
      }

	    axios({
        url: '/identity/password',
        baseURL: window.settings.apiBaseUrl,
        method: 'post',
        params: {
          'site': window.settings.internalName
        },
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': window.settings.baseAPIKey
        },
        data: JSON.stringify(data)
	    }).then((response) => {
	        if (response.data.passwordUpdated) {
            this.setState({ passwordUpdated: true })
          }
          if (!this.props.simplified) this.redirectToHomepage(3000)
        }).catch(error =>{
          this.setState({ errorMessage: this.getVal(error.response.data.code) || error.response.data.error })
      })
    }
  }

  handleChange = (e) => {
    e.target.classList.add('active')

    this.setState({
      [e.target.name]: e.target.value
    })

    if (!this.props.simplified) this.showInputError(e.target.name)
  }

  showFormErrors = () => {
    const inputs = document.querySelectorAll('.form-group input')
    let isFormValid = true

    inputs.forEach(input => {
      input.classList.add('active')

      const isInputValid = this.showInputError(input.name)

      if (!isInputValid) {
        isFormValid = false
      }
    })

    return isFormValid
  }

  showInputError = (refName) => {
    const validity = this.refs[refName].validity
    const error = document.getElementById(`${refName}Error`)
    const isPassword = refName.indexOf('password') !== -1
    const isPasswordConfirm = refName === 'passwordConfirm'

    if (isPasswordConfirm) {
      if (this.refs.password.value !== this.refs.passwordConfirm.value) {
        this.refs.passwordConfirm.setCustomValidity('Passwords do not match')
      } else {
        this.refs.passwordConfirm.setCustomValidity('')
      }
    }

    if (!validity.valid) {
      if (validity.valueMissing) {
        error.textContent = this.getVal(refName) +' '+ this.getVal('requiredError')
      } else if (isPassword && validity.patternMismatch) {
        error.textContent = this.getVal(refName) +' '+ this.getVal('passwordLengthError')
      } else if (isPasswordConfirm && validity.customError) {
        error.textContent = this.getVal('passwordMismatchError')
      }
      return false
    }

    error.textContent = ''
    return true
  }

  regularForm() {
    return (
      <form name="resetPassword" onSubmit={this.handleSubmit} noValidate>
        <div className="form-group">
          <label id="passwordLabel">{this.getVal('password')}</label>
          <input
            type="password"
            name="password"
            ref="password"
            placeholder={this.getVal('password')}
            value={ this.state.password }
            onChange={ this.handleChange }
            pattern=".{5,}"
            autoComplete="false"
            required 
          />
          <div className="error" id="passwordError" />
        </div>
        <div className="form-group">
          <label id="passwordConfirmLabel">{this.getVal('passwordConfirm')}</label>
          <input
            type="password"
            name="passwordConfirm"
            placeholder={this.getVal('passwordConfirm')}
            ref="passwordConfirm"
            value={ this.state.passwordConfirm }
            onChange={ this.handleChange }
            autoComplete="false"
            required />
          <div className="error" id="passwordConfirmError">{this.state.errorMessage}</div>
        </div>
        <div className="button-container">
          <button 
            type="submit" 
            className="button reset-submit site-border-color" 
            value={this.getVal('savePasswordCta')}
            onClick={this.handleSubmit}
          >
            {this.getVal('savePasswordCta')}
          </button>
        </div>
      </form>
    )
  }

  shortForm = () => {
  const pwUpdated = this.state.passwordUpdated
    return (
      <div>
        <h1>{ pwUpdated ? this.getVal('passwordSavedHeader') : this.getVal('createPasswordHeader') }</h1>
        <form name="resetPassword">
          { !pwUpdated && <input 
            name="password" 
            type="password"
            placeholder={this.getVal('passwordCreate')}
            value={this.state.password} 
            onChange={this.handleChange}
          /> }
          <button 
            className="primary-button black"
            onClick={(e) => {
              e.preventDefault()
              if (pwUpdated) { 
                window.location = '/reset-password?pw=passwordUpdated'
              } else {
                this.handleSubmit(e)
              }
            }}
          >                                  
          { pwUpdated ? this.getVal('backToSignIn') : this.getVal('savePasswordCta') }
          </button>
          <div className="error" id="passwordConfirmError">{this.state.errorMessage}</div>
        </form>
      </div>
    ) 
  }

  renderForm() {
    if (this.state.validToken && !this.state.checkingToken) {
      if (!this.state.passwordUpdated && !this.props.simplified) {
        return (
          <div className="form-container">
            <div className="header">{this.getVal('header')}</div>
              { this.regularForm() }
          </div>
        )
      } else if (this.props.simplified) {
        return (
          <div className="form-container">
            { this.shortForm() }
          </div>
        )
      }
    }
  }

  redirectToHomepage = (val) => setTimeout(() => window.location.href = '/', val)

  render() {
    return (
      <div className="reset-password site-color">
        { this.renderForm() }

        { (!this.state.validToken && this.state.validToken !== '') &&
          <div className="reset-password">
            {this.getVal('tokenExpired')}
          </div> }

        { this.state.passwordUpdated &&
          <div className="password-changed header">
            {this.getVal('passwordChangedMessage')}
          </div> }
      </div>
    )
  }
}

export default resetForm